import Vue from 'vue'

import Vuex from 'vuex'
Vue.use(Vuex)

import user from '@/store/user'
import orderhead from '@/store/orderhead'
import orderitem from '@/store/orderitem'
import ledger from '@/store/ledger'
import cartrule from '@/store/cartrule'
import betlimit from '@/store/betlimit'
import round from '@/store/round'
import yeekee from '@/store/yeekee'
import lottoresult from '@/store/lottoresult'
import jobtask from '@/store/jobtask'
import affiliate from '@/store/affiliate'
import usernumber from '@/store/usernumber'
import information from '@/store/information'


const store = new Vuex.Store({
    modules: {
        user,
        orderhead,
        orderitem,
        ledger,
        cartrule,
        betlimit,
        round,
        yeekee,
        lottoresult,
        jobtask,
        affiliate,
        usernumber,
        information
    }
})

export default store
